import { render } from "./pagination.html?vue&type=template&id=39bad77a&scoped=true&ts=true"
import script from "./pagination.ts?vue&type=script&lang=ts"
export * from "./pagination.ts?vue&type=script&lang=ts"

import "./pagination.scss?vue&type=style&index=0&id=39bad77a&lang=scss&scoped=true"

import exportComponent from "/Users/fahadnaeem/Documents/MYLE Codes/myle-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39bad77a"]])

export default __exports__